import { DanceManagerUserInviteTokenExpirationTimeEnum, DanceManagerUserRoleEnum } from '../../enums';

export interface DanceManagerUserInviteRequestInterface {
  role: DanceManagerUserRoleEnum;
  email?: string;
  expirationTime?: DanceManagerUserInviteTokenExpirationTimeEnum;
}
